import * as D from "./data";
import * as S from "./style";
import { useClientHeight, useToggle } from "./logics";
import { useRef } from "react";
import { swc } from "@teamsparta/design-system";
import { logCourseTitle, sendLog } from "@/businessLogics/_common/logging";

export interface Course {
  title: string;
  lectures: string[];
}

export interface Detail {
  week: string;
  courses: Course[];
}

export interface Curriculum {
  title: string;
  period: string;
  goals: string[];
  details: Detail[];
}

export default function Template({
  course,
  curriculum: c,
  seq,
  offset = 0,
  idx,
  lastStepIdx,
}: {
  course: string;
  curriculum: Curriculum;
  seq: number;
  offset: number;
  idx: number;
  lastStepIdx: number;
}) {
  const wrapper = useRef(null);
  const [toggle, setToggle] = useToggle(false);
  const height = useClientHeight(wrapper, [toggle]);

  function clickCurriculumDetailToggle(seq: number, step_title: string) {
    setToggle();
    sendLog(`sw_${logCourseTitle[course]}_curri_click`, {
      step: `${seq}`,
      step_title,
    });
  }

  return (
    <S.Wrapper ref={wrapper}>
      <S.Vertical
        className="vertical"
        height={height + offset}
        idx={idx}
        lastStepIdx={lastStepIdx}
      />
      <S.Title
        isBlackTitle={c.title === "사전 스터디" || c.title === "취업 지원"}
      >
        <S.Label
          isOTweek={c.title === "사전 스터디"}
          isBlackLabel={c.title === "사전 스터디" || c.title === "취업 지원"}
        >
          <div>{seq === -1 ? "OT" : seq}</div>
        </S.Label>
        <span>{c.title}</span>
        {c.period.length ? <small>({c.period})</small> : null}
      </S.Title>
      <S.GoalContainer>
        <S.GoalLabel>
          <D.GoalLabel />
        </S.GoalLabel>
        {c.goals.map((goal, idx) => (
          <S.Goal key={goal}>
            {c.goals.length > 1 && `${idx + 1}.`} {goal}
          </S.Goal>
        ))}
      </S.GoalContainer>
      {c.period.length ? (
        <S.DetailWrapper>
          <S.DetailHeader
            onClick={() => {
              clickCurriculumDetailToggle(seq, c.title);
            }}
          >
            <span>
              <D.DetailHeader />
            </span>
            <S.ToggleWrapper isTrue={toggle}>
              <svg
                width="15"
                height="8"
                viewBox="0 0 15 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.78426 7.70711C1.39373 8.09763 0.760566 8.09763 0.370042 7.70711C-0.0204826 7.31658 -0.0204827 6.68342 0.370042 6.29289L1.78426 7.70711ZM7.07715 0.999999L6.37004 0.292893C6.76057 -0.0976315 7.39373 -0.0976315 7.78425 0.292893L7.07715 0.999999ZM13.7843 6.29289C14.1748 6.68342 14.1748 7.31658 13.7843 7.70711C13.3937 8.09763 12.7606 8.09763 12.37 7.70711L13.7843 6.29289ZM0.370042 6.29289L6.37004 0.292893L7.78425 1.70711L1.78426 7.70711L0.370042 6.29289ZM7.78425 0.292893L13.7843 6.29289L12.37 7.70711L6.37004 1.70711L7.78425 0.292893Z"
                  fill={swc.blue}
                />
              </svg>
            </S.ToggleWrapper>
          </S.DetailHeader>
          {toggle && (
            <S.DetailContainer>
              {c.details.map((detail) => (
                <S.Detail key={detail.week}>
                  <span>{detail.week}</span>
                  <ul>
                    {detail.courses.map((course) => (
                      <li key={course.title}>
                        <S.CourseTitle isNotList={course.lectures.length === 1}>
                          {!!course.title && `[${course.title}]`}
                          <ul>
                            {course.lectures.map((lecture) => (
                              <li key={lecture}>{lecture}</li>
                            ))}
                          </ul>
                        </S.CourseTitle>
                      </li>
                    ))}
                  </ul>
                </S.Detail>
              ))}
            </S.DetailContainer>
          )}
        </S.DetailWrapper>
      ) : null}
    </S.Wrapper>
  );
}
